import MainFilterSearchBox from "./MainFilterSearchBox";
import {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";

const heroLines = [["Najlepsze wakacje to te na Twoich zasadach.", "Pomożemy Ci zorganizować wymarzoną podróż."]];

const Index = () => {
  const [copy] = useState(() => heroLines[Math.floor(Math.random() * heroLines.length)]);
  const [offers, setOffers] = useState([]);
  const offerTrack = useRef(null);
  const dragState = useRef({active: false, moved: false, startX: 0, startScroll: 0});
  useEffect(() => {
    fetch("https://api.tripsi.pl/api/trips/find?pageSize=8&pageNumber=1&uniqueDestinations=true&sort=pricePerDay")
      .then(response => response.ok ? response.json() : Promise.reject(response))
      .then(data => setOffers(data.content || []))
      .catch(() => {});
  }, []);
  const offerData = index => offers[index] || {};
  const offerDestination = index => offerData(index).destination || offerData(index).destinationData || {};
  const offerName = index => offerDestination(index).name || offerDestination(index).inName || offerDestination(index).toName || "wybranym kierunku";
  const offerPrice = index => Number(offerData(index).pricePerPerson ?? offerData(index).price ?? offerData(index).priceWithCurrency?.amount ?? 0);
  const offerImage = (index, fallback) => offerDestination(index).wordpressPhoto || offerDestination(index).photoUrl || offerDestination(index).photo || fallback;
  const visibleOffers = offers.length ? offers : [{}, {}];
  const startDragging = event => {
    const track = offerTrack.current;
    if (!track) return;
    dragState.current = {active: true, moved: false, startX: event.clientX, startScroll: track.scrollLeft};
    track.setPointerCapture(event.pointerId);
  };
  const dragOffers = event => {
    if (!dragState.current.active || !offerTrack.current) return;
    const distance = event.clientX - dragState.current.startX;
    if (Math.abs(distance) > 5) dragState.current.moved = true;
    offerTrack.current.scrollLeft = dragState.current.startScroll - distance;
  };
  const stopDragging = event => {
    dragState.current.active = false;
    if (event.pointerId !== undefined && offerTrack.current?.hasPointerCapture(event.pointerId)) offerTrack.current.releasePointerCapture(event.pointerId);
  };
  const startMouseDragging = event => {
    const track = offerTrack.current;
    if (!track) return;
    dragState.current = {active: true, moved: false, startX: event.clientX, startScroll: track.scrollLeft};
  };
  return (
    <section className="masthead -type-10">
      <div className="container-1500">
        <div className="row">
          <div className="col-lg-auto">
            <div className="masthead__content">
              {/* Keep the above-the-fold entrance in CSS rather than AOS so it starts as soon
                  as styles are ready and does not wait for scroll-observer initialization. */}
              <div className="masthead__copy">
                <h1 className="text-60 lg:text-40 sm:text-30">
                  {copy[0]}
                </h1>
                <p className="mt-5">
                  {/*Odkryj unikalne kombinacje lotów i hoteli w niskiej cenie*/}
                  {/*Pierwsza wyszukiwarka skoncentrowana na elastycznych terminach*/}
                  {/*Pierwsza wyszukiwarka która pomoże znaleźć C*/}
                  {copy[1]}
                </p>
              </div>
              <div>
                <div className="row y-gap-20 items-center pt-30">
                  {/*<FilterSelect />*/}
                </div>
                {/* End .row */}

                <MainFilterSearchBox customStyle={"-w-1070"} />
                {/* End filter content */}
              </div>
            </div>
            {/* End .masthead__content */}
          </div>
          {/* End .col-lg-auto */}
        </div>
        {/* End .row */}

        {/* The lead photo stays fetch-priority high; the remaining offer cards load lazily. */}
        <div
          className="masthead__image"
          ref={offerTrack}
          role="region"
          aria-label="Polecane oferty. Przeciągnij, aby zobaczyć więcej."
          onPointerDown={startDragging}
          onPointerMove={dragOffers}
          onPointerUp={stopDragging}
          onPointerCancel={stopDragging}
          onMouseDown={startMouseDragging}
          onMouseMove={dragOffers}
          onMouseUp={stopDragging}
          onMouseLeave={stopDragging}
          onClickCapture={event => { if (dragState.current.moved) event.preventDefault(); }}
        >
          <div className="row y-gap-30 flex-nowrap heroOfferTrack">
            {visibleOffers.map((offer, index) => (
            <div className="col-auto heroOfferPhoto" key={offer.id || index}>
              {offers[index] ? (
                <Link
                  className="heroOfferPhoto__image"
                  to={`/tour-single/${offers[index].id}`}
                  aria-label={`Zobacz ofertę: ${offerName(index)}`}
                >
                  <img
                    src={offerImage(index, index === 0 ? "/img/masthead/10/holiday-1.webp" : "/img/masthead/10/holiday-2.jpg")}
                    alt={`Oferta wakacji: ${offerName(index)}`}
                    className="rounded-16"
                    width={index === 0 ? "550" : "290"}
                    height="560"
                    fetchPriority={index === 0 ? "high" : undefined}
                    loading={index === 0 ? undefined : "lazy"}
                    draggable="false"
                    onError={event => {event.currentTarget.src=index === 0 ? "/img/masthead/10/holiday-1.webp" : "/img/masthead/10/holiday-2.jpg"}}
                  />
                </Link>
              ) : (
                <img
                  src={offerImage(index, index === 0 ? "/img/masthead/10/holiday-1.webp" : "/img/masthead/10/holiday-2.jpg")}
                  alt="Wakacyjna inspiracja"
                  className="rounded-16"
                  width={index === 0 ? "550" : "290"}
                  height="560"
                  fetchPriority={index === 0 ? "high" : undefined}
                  loading={index === 0 ? undefined : "lazy"}
                  draggable="false"
                  onError={event => {event.currentTarget.src=index === 0 ? "/img/masthead/10/holiday-1.webp" : "/img/masthead/10/holiday-2.jpg"}}
                />
              )}
              {offers[index] && <Link className="heroOfferPhoto__hint" to={`/tour-single/${offers[index].id}`}><span>Może {offerName(index)}?</span><strong>Od {Math.round(offerPrice(index))} zł/os. →</strong></Link>}
            </div>
            ))}
          </div>
          {/* End .row */}
        </div>
        {/* End .masthead__image */}
      </div>
      {/* End .container */}
    </section>
  );
};

export default Index;
